/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KapacitorAlert
 */
export interface KapacitorAlert {
    /**
     * 
     * @type {string}
     * @memberof KapacitorAlert
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof KapacitorAlert
     */
    level: string;
    /**
     * 
     * @type {string}
     * @memberof KapacitorAlert
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof KapacitorAlert
     */
    details: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof KapacitorAlert
     */
    data: { [key: string]: string | undefined; };
}

export function KapacitorAlertFromJSON(json: any): KapacitorAlert {
    return KapacitorAlertFromJSONTyped(json, false);
}

export function KapacitorAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): KapacitorAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'level': json['level'],
        'message': json['message'],
        'details': json['details'],
        'data': json['data'],
    };
}

export function KapacitorAlertToJSON(value?: KapacitorAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'level': value.level,
        'message': value.message,
        'details': value.details,
        'data': value.data,
    };
}


